import {
  DEVICE_STATUS_ACTIVE,
  DEVICE_STATUS_INACTIVE,
} from "../store/Device/DeviceConstant";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { Badge } from "@mui/material";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      background: "#00a65a",
      color: "#FFF",
      padding: "4px 10px",
    },
    inactive: {
      background: "#dd4b39",
      color: "#FFF",
      padding: "4px 10px",
    },
  })
);

const DeviceStatus = (props: any) => {
  const classes = useStyles();
  const { value } = props;

  if (value === DEVICE_STATUS_ACTIVE) {
    return (
      <Badge
        badgeContent="В&nbsp;сети"
        classes={{ badge: classes.active }}
      ></Badge>
    );
  }

  if (value === DEVICE_STATUS_INACTIVE) {
    return (
      <Badge
        badgeContent="Не&nbsp;в&nbsp;сети"
        classes={{ badge: classes.inactive }}
      ></Badge>
    );
  }

  return <>&nbsp;</>;
};

export default DeviceStatus;
